import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class BackendInterceptor implements HttpInterceptor {
	constructor(protected _authService: AuthService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let esUrlGeoref = req.url.includes(environment.georef_api_url);

		// Cargamos el header authorization con el access token si el token está vigente y si no es una petición a la api de georef
		if (this._authService.isAuthenticated() && !esUrlGeoref) {
			req = req.clone({
				headers: req.headers.set('Authorization', 'Bearer ' + this._authService.getIdToken()),
			});
		}

		return next.handle(req);
	}
}
